<template>
    <div
        data-spec-class="base-tab"
        :data-spec-value="isActive ? 'active' : 'inactive'"
    >
        <a
            href="#"
            :class="classObject"
            @click.prevent="$emit('activate', id)"
        >
            <span> {{ label }} </span>
            <BaseBadge
                v-if="badge"
                class="ml-3"
                >{{ badge }}</BaseBadge
            >
        </a>
    </div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults, defineEmits, computed } from 'vue';
import { TabsItemTheme } from '@/types';
import BaseBadge from './BaseBadge.vue';

defineEmits(['activate']);

interface Props {
    id: string;
    label: string;
    isActive?: boolean;
    theme?: TabsItemTheme;
    badge?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
    isActive: false,
    theme: TabsItemTheme.Normal,
    badge: undefined,
});

const normalClassObject = computed(() => ({
    'transition-ease pb-4 border-b-2 px-1.5': true,
    'text-brand border-brand': props.isActive,
    'text-tertiary border-transparent hover:text-brand': !props.isActive,
}));

const cardClassObject = computed(() => ({
    'inline-block px-0 sm:px-6 py-3 h-full w-full rounded-t transition-ease': true,
    'text-sm sm:text-lg text-center font-medium': true,
    'border-t border-r border-l border-divider': true,
    'bg-surface text-secondary cursor-default': props.isActive,
    'bg-page text-tertiary hover:text-secondary hover:bg-surface border-b border-divider':
        !props.isActive,
}));

const classObject = computed(() => {
    switch (props.theme) {
        case TabsItemTheme.Normal:
            return normalClassObject.value;
        case TabsItemTheme.Card:
            return cardClassObject.value;
        default:
            return normalClassObject.value;
    }
});
</script>
